// Debug utility to check reference range fetching
export const debugReferenceRanges = (trendsData: any) => {
  console.group('🔍 Reference Range Debug');
  
  Object.entries(trendsData).forEach(([testName, trend]: [string, any]) => {
    console.group(`Test: ${testName}`);
    console.log('Units:', trend.units);
    console.log('Data points:', trend.dataPoints.length);
    
    if (trend.dataPoints.length > 0) {
      const firstPoint = trend.dataPoints[0];
      console.log('First data point:', {
        value: firstPoint.value,
        referenceMin: firstPoint.referenceMin,
        referenceMax: firstPoint.referenceMax,
        hasReference: firstPoint.referenceMin !== null && firstPoint.referenceMax !== null
      });
      
      // Check if any point has reference ranges
      const hasAnyReference = trend.dataPoints.some(
        (point: any) => point.referenceMin !== null && point.referenceMax !== null
      );
      console.log('Has any reference range:', hasAnyReference);
    }
    
    console.groupEnd();
  });
  
  console.groupEnd();
};